// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__osjRz","savePackageButton":"ClientWallet_savePackageButton__1PYpP"};